shadow$provide[340] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Line:{enumerable:true, get:function() {
  return Line;
}}});
var require$three = require("three");
var require$_DOT__SLASH_base_DOT_js = require("./base.js");
var require$_DOT__DOT__SLASH_geometry_SLASH_linegeometry_DOT_js = require("../geometry/linegeometry.js");
class Line extends require$_DOT__SLASH_base_DOT_js.Base {
  constructor(renderer, shaders, options) {
    let left;
    super(renderer, shaders, options);
    let {uniforms, stroke, join} = options;
    const {material, position, color, mask, map, combine, stpq, linear, clip, proximity, closed} = options;
    if (uniforms == null) {
      uniforms = {};
    }
    stroke = [null, "dotted", "dashed"][stroke];
    const hasStyle = uniforms.styleColor != null;
    join = (left = ["miter", "round", "bevel"][join]) != null ? left : "miter";
    const detail = {miter:1, round:4, bevel:2}[join];
    this.geometry = new require$_DOT__DOT__SLASH_geometry_SLASH_linegeometry_DOT_js.LineGeometry({samples:options.samples, strips:options.strips, ribbons:options.ribbons, layers:options.layers, anchor:options.anchor, closed:options.closed, detail,});
    this._adopt(uniforms);
    this._adopt(this.geometry.uniforms);
    const factory = shaders.material();
    const defs = {};
    if (stroke) {
      defs.LINE_STROKE = "";
    }
    if (clip) {
      defs.LINE_CLIP = "";
    }
    if (proximity != null) {
      defs.LINE_PROXIMITY = "";
    }
    defs["LINE_JOIN_" + join.toUpperCase()] = "";
    if (detail > 1) {
      defs["LINE_JOIN_DETAIL"] = detail;
    }
    if (closed) {
      defs["LINE_CLOSED"] = "";
    }
    const v = factory.vertex;
    v.pipe(this._vertexColor(color, mask));
    v.require(this._vertexPosition(position, material, map, 2, stpq));
    v.pipe("line.position", this.uniforms, defs);
    v.pipe("project.position", this.uniforms);
    const f = factory.fragment;
    if (stroke) {
      f.pipe(`fragment.clip.${stroke}`, this.uniforms);
    }
    if (clip) {
      f.pipe("fragment.clip.ends", this.uniforms);
    }
    if (proximity != null) {
      f.pipe("fragment.clip.proximity", this.uniforms);
    }
    f.pipe(this._fragmentColor(hasStyle, material, color, mask, map, 2, stpq, combine, linear));
    f.pipe("fragment.color", this.uniforms);
    const opts = factory.link({side:require$three.DoubleSide,});
    this.material = this._material(opts);
    const object = new require$three.Mesh(this.geometry, this.material);
    object.userData = opts;
    this._raw(object);
    this.renders = [object];
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
    this.renders = this.geometry = this.material = null;
    return super.dispose();
  }
}

};